module.exports = __webpack_public_path__ + "static/media/bg-idisc-header-contacto.bfe1a36a.png";